export function parseYearMonthToLastDate(yearMonth) {
  const [year, month] = yearMonth.split('-').map(Number)
  return new Date(year, month, 0)
}
